export const IconHamburger = () => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 141.73 141.73"
  >
    <g>
      <rect x="4.6" y="105.4" width="97.1" height="17.7" />
      <rect x="119.4" y="105.4" width="17.7" height="17.7" />
    </g>
    <g>
      <rect x="4.6" y="62" width="97.1" height="17.7" />
      <rect x="119.4" y="62" width="17.7" height="17.7" />
    </g>
    <g>
      <rect x="4.6" y="18.6" width="97.1" height="17.7" />
      <rect x="119.4" y="18.6" width="17.7" height="17.7" />
    </g>
  </svg>
);

export const IconX = () => (
  <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 141.7 141.7">
    <rect
      x="-2.6"
      y="62.2"
      transform="matrix(0.7071 -0.7071 0.7071 0.7071 -29.3746 70.8842)"
      width="146.9"
      height="17.4"
    />
    <rect
      x="62.2"
      y="-2.6"
      transform="matrix(0.7071 -0.7071 0.7071 0.7071 -29.325 70.8652)"
      width="17.4"
      height="146.9"
    />
  </svg>
);
